const actionTypes = {
  team: {
    updateActiveTeam: 'team/updateActiveTeam',
    updateTeams: 'team/updateTeams'
  },
  division: {
    updateDivisions: 'team/updateDivisions',
    updateActiveDivision: 'team/updateActiveDivision'
  },
  chart: {
    updateChart: 'chart/updateChart'
  },
  chartsPage: {
    setSelectFilter: 'chartsPage/setSelectFilter',
    getCharts: 'chartsPage/getCharts',
    getTags: 'chartsPage/getTags',
    pageUpdate: 'chartsPage/pageUpdated',
    getCreators: 'chartsPage/getCreators',
    deleteChart: 'chartsPage/deleteChart',
    recoverChart: 'chartsPage/recoverChart',
    convertToTheme: 'chartsPage/convertToTheme',
    duplicateToTheme: 'chartsPage/duplicateToTheme',
    duplicateChart: 'chartsPage/duplicateChart',
    setChartMeta: 'chartsPage/setChartMeta',

    set: 'chartsPage/set',
    updateCharts: 'chartsPage/updateCharts'
  },
  customiseEditorPage: {
    getEditorConfig: 'customiseEditorPage/getEditorConfig',
    set: 'customiseEditorPage/set',
    getUserEditorConfig: 'customiseEditorPage/getUserEditorConfig',
    setUserEditorConfig: 'customiseEditorPage/setUserEditorConfig',
    getFonts: 'customiseEditorPage/getFonts',
    deleteFont: 'customiseEditorPage/deleteFont',
    deleteLogo: 'customiseEditorPage/deleteLogo',
    getLogos: 'customiseEditorPage/getLogos'
  },
  plansPage: {
    set: 'plansPage/set',
    getAccountId: 'plansPage/getAccountId',
    getTeamPlans: 'plansPage/getTeamPlans',
    getPlans: 'plansPage/getPlans',
    getCoupon: 'plansPage/getCoupon',
    deletePlan: 'plansPage/deletePlan',
    updatePlan: 'plansPage/updatePlan'
  },
  billingPage: {
    set: 'billingPage/set',
    getSummary: 'billingPage/getSummary'
  },
  billingHistoryPage: {
    set: 'billingHistoryPage/set',
    getAdjustments: 'billingHistoryPage/getAdjustments',
    getSubHistory: 'billingHistoryPage/getSubHistory',
    downloadInvoice: 'billingHistoryPage/downloadInvoice'
  },
  settingsPage: {
    set: 'settingsPage/set',
    getTeamProfile: 'settingsPage/getTeamProfile',
    setTeamSettings: 'settingsPage/setTeamSettings',
    deleteTeam: 'settingsPage/deleteTeam',
    verifyEmail: 'settingsPage/verifyEmail',
    setUserSettings: 'settingsPage/setUserSettings',
    generateLicense: 'settingsPage/generateLicense',
    getCMSLicense: 'settingsPage/getCMSLicense'
  },
  teamMembersPage: {
    set: 'teamMembersPage/set',
    updateUsersGroup: 'teamMembersPage/updateUsersGroup',
    updateDivisionMembers: 'teamMembersPage/updateDivisionMembers',
    getMembers: 'teamMembersPage/getMembers',
    getDivisionMembers: 'teamMembersPage/getDivisionMembers',
    deleteTeamUsers: 'teamMembersPage/deleteTeamUsers'
  },
  ShowChartPage: {
    set: 'ShowChartPage/set',
    createChart: 'ShowChartPage/createChart',
    loadChart: 'ShowChartPage/loadChart',
    editChart: 'ShowChartPage/editChart',
    duplicateChart: 'ShowChartPage/duplicateChart',
    createLayout: 'ShowChartPage/createLayout',
    createTable: 'ShowChartPage/createTable'
  },
  teamInvitationsPage: {
    set: 'teamInvitationsPage/set',
    getInvitations: 'teamInvitationsPage/getInvitations',
    deleteInvitation: 'teamInvitationsPage/deleteInvitation',
    deleteInvitations: 'teamInvitationsPage/deleteInvitations',
    setInvitations: 'teamInvitationsPage/setInvitations',
    resendInvitation: 'teamInvitationsPage/resendInvitation',
    getPlanDetails: 'teamInvitationsPage/getPlanDetails'
  },
  teamWebhooksPage: {
    set: 'teamWebhooksPage/set',
    getWebhooks: 'teamWebhooksPage/getWebhooks',
    getSupportedWebhooks: 'teamWebhooksPage/getSupportedWebhooks',
    setWebhook: 'teamWebhooksPage/setWebhook',
    updateWebhook: 'teamWebhooksPage/updateWebhook',
    deleteWebhooks: 'teamWebhooksPage/deleteWebhooks'
  },
  teamGroupsPage: {
    set: 'teamGroupsPage/set',
    getPermissions: 'teamGroupsPage/getPermissions',
    getGroupPermissions: 'teamGroupsPage/getGroupPermissions',
    setGroup: 'teamGroupsPage/setGroup',
    updateGroup: 'teamGroupsPage/updateGroup',
    deleteGroup: 'teamGroupsPage/deleteGroup',
    setGroupPermissions: 'teamGroupsPage/setGroupPermissions'
  },
  apiPage: {
    set: 'apiPage/set',
    getTeamKeys: 'apiPage/getTeamKeys',
    updateKey: 'apiPage/updateKey',
    deleteKeys: 'apiPage/deleteKeys',
    setTeamKey: 'apiPage/setTeamKey'
  },
  themesPage: {
    set: 'themesPage/set',
    getTeamThemes: 'themesPage/getTeamThemes'
  },
  layoutEditor: {
    set: 'layoutEditor/set',
    initEditor: 'layoutEditor/initEditor',
    getPublishedCharts: 'layoutEditor/getPublishedCharts',
    setPageTemplate: 'layoutEditor/setPageTemplate',
    updatePageTemplate: 'layoutEditor/updatePageTemplate',
    closeWizard: 'layoutEditor/closeWizard',
    setResolution: 'layoutEditor/setResolution',
    saveLayout: 'layoutEditor/saveLayout',
    addChartToGridSuccess: 'layoutEditor/addChartToGridSuccess',
    loadLayout: 'layoutEditor/loadLayout',
    toggleChartModal: 'layoutEditor/toggleChartModal',
    addChartToGrid: 'layoutEditor/addChartToGrid',
    addImageToGrid: 'layoutEditor/addImageToGrid',
    addToGrid: 'layoutEditor/addToGrid',
    changeTitleText: 'layoutEditor/changeTitleText',
    updateCustomizedProp: 'layoutEditor/updateCustomizedProp',
    updateDataProp: 'layoutEditor/updateDataProp',
    openPublishModal: 'layoutEditor/openPublishModal',
    closePublishModal: 'layoutEditor/closePublishModal',
    publishLayout: 'layoutEditor/publishLayout',
    assignTheme: 'layoutEditor/assignTheme',
    removeChartFromDataOptions: 'layoutEditor/removeChartFromDataOptions',
    getFonts: 'layoutEditor/getFonts',
    getLogos: 'layoutEditor/getLogos',
    resetState: 'layoutEditor/resetState',
    toggleCMSModal: 'layoutEditor/toggleCMSModal',
    redrawProject: 'layoutEditor/redrawProject',
    remove: 'layoutEditor/remove'
  },
  tableEditor: {
    set: 'tableEditor/set',
    initEditor: 'tableEditor/initEditor',
    closeWizard: 'tableEditor/closeWizard',
    saveTable: 'tableEditor/saveTable',
    loadTable: 'tableEditor/loadTable',
    changeTitleText: 'tableEditor/changeTitleText',
    updateCustomizedProp: 'tableEditor/updateCustomizedProp',
    updateDataProp: 'tableEditor/updateDataProp',
    publishTable: 'tableEditor/publishTable',
    assignTheme: 'tableEditor/assignTheme',
    setData: 'tableEditor/setData',
    resetData: 'tableEditor/resetData',
    loadPaginated: 'tableEditor/loadPaginated',
    goToNextPage: 'tableEditor/goToNextPage',
    goToPreviousPage: 'tableEditor/goToPreviousPage',
    search: 'tableEditor/search',
    updateData: 'tableEditor/updateData',
    changeColumnOrder: 'tableEditor/changeColumnOrder',
    processConditionalFormatting: 'tableEditor/processConditionalFormatting',
    changeRowOrder: 'tableEditor/changeRowOrder',
    deleteRow: 'tableEditor/deleteRow',
    deleteColumn: 'tableEditor/deleteColumn',
    addChartToTable: 'tableEditor/addChartToTable',
    updateChartHeader: 'tableEditor/updateChartHeader',
    updateCustomizedArrayProp: 'tableEditor/updateCustomizedArrayProp',
    updateColumnHiddenValue: 'tableEditor/updateColumnHiddenValue',
    addRow: 'tableEditor/addRow',
    addColumn: 'tableEditor/addColumn',
    resetTableState: 'tableEditor/resetTableState',
    setCellSetting: 'tableEditor/setCellSetting',
    mergeCells: 'tableEditor/mergeCells',
    setDataStyle: 'tableEditor/setDataStyle',
    removeDataStyle: 'tableEditor/removeDataStyle',
    toggleDataStyle: 'tableEditor/toggleDataStyle',
    setBordersAllEdges: 'tableEditor/setBordersAllEdges',
    deleteBulkCellValues: 'tableEditor/deleteBulkCellValues',
    setBorderStyle: 'tableEditor/setBorderStyle',
    openExportModal: 'tableEditor/openExportModal',
    closeExportModal: 'tableEditor/closeExportModal',
    showContextMenu: 'tableEditor/showContextMenu',
    hideContextMenu: 'tableEditor/hideContextMenu',
    redrawTable: 'tableEditor/redrawTable',
    editDataGrid: 'tableEditor/editDataGrid',
    deleteAssignRawOption: 'tableEditor/deleteAssignRawOption',
    addAssignRawOption: 'tableEditor/addAssignRawOption',
    updateAssignRawOption: 'tableEditor/updateAssignRawOption',
    filterData: 'tableEditor/filterData'
  },
  chartEditor: {
    initSettings: 'chartEditor/initSettings',
    set: 'chartEditor/set',
    saveChart: 'chartEditor/saveChart',
    publishChart: 'chartEditor/publishChart',
    assignTheme: 'chartEditor/assignTheme',
    initEditor: 'chartEditor/initEditor',
    setTemplate: 'chartEditor/setTemplate',
    loadCSV: 'chartEditor/loadCSV',
    loadMapCSV: 'chartEditor/loadMapCSV',
    setCustomizedOptions: 'chartEditor/setCustomizedOptions',
    addBlankSeries: 'chartEditor/addBlankSeries',
    deleteSeries: 'chartEditor/deleteSeries',
    loadProject: 'chartEditor/loadProject',
    deleteSingleSeries: 'chartEditor/deleteSingleSeries',
    clearData: 'chartEditor/clearData',
    loadGoogleSheet: 'chartEditor/loadGoogleSheet',
    loadLiveData: 'chartEditor/loadLiveData',
    updateCustomized: 'chartEditor/updateCustomized',
    updateCustomizedBulk: 'chartEditor/updateCustomizedBulk',
    deleteCustomized: 'chartEditor/deleteCustomized',
    loadChart: 'chartEditor/loadChart',
    setMap: 'chartEditor/setMap',
    setCustomCode: 'chartEditor/setCustomCode',
    redrawProject: 'chartEditor/redrawProject',
    resetState: 'chartEditor/resetState',
    setData: 'chartEditor/setData',
    addAnnotation: 'chartEditor/addAnnotation',
    removeAnnotation: 'chartEditor/removeAnnotation',
    removeHighlight: 'chartEditor/removeHighlight',
    onChangeActiveAnnotation: 'chartEditor/onChangeActiveAnnotation',
    updateLabelAnnotation: 'chartEditor/updateLabelAnnotation',
    updateLineAnnotation: 'chartEditor/updateLineAnnotation',
    updateAnnotations: 'chartEditor/updateAnnotations',
    showAnnotationInMenu: 'chartEditor/showAnnotationInMenu',
    addHighlight: 'chartEditor/addHighlight',
    updateHighlightAnnotation: 'chartEditor/updateHighlightAnnotation',
    useGeoJSONMap: 'chartEditor/useGeoJSONMap',
    showGeoJSONModal: 'chartEditor/showGeoJSONModal',
    hideGeoJSONModal: 'chartEditor/hideGeoJSONModal',
    updateMapData: 'chartEditor/updateMapData',
    setGeoJSONMap: 'chartEditor/setGeoJSONMap',
    closePublishModal: 'chartEditor/closePublishModal',
    openPublishModal: 'chartEditor/openPublishModal',
    toggleSignupModal: 'chartEditor/toggleSignupModal',
    closeCMSModal: 'chartEditor/closeCMSModal',
    closeWizard: 'chartEditor/closeWizard',
    loadChartFromUUID: 'chartEditor/loadChartFromUUID',
    addItemArray: 'chartEditor/addItemArray',
    deleteItemArray: 'chartEditor/deleteItemArray',
    updateDataLabel: 'chartEditor/updateDataLabel',
    updateDataRelatedProp: 'chartEditor/updateDataRelatedProp',
    updateBasedOnDataProp: 'chartEditor/updateBasedOnDataProp',
    editDataGrid: 'chartEditor/editDataGrid',
    addDataGridSeries: 'chartEditor/addDataGridSeries',
    deleteDataGridSeries: 'chartEditor/deleteDataGridSeries',
    sortData: 'chartEditor/sortData',
    updateChartCategories: 'chartEditor/updateChartCategories',
    updateChartSeries: 'chartEditor/updateChartSeries',
    addChartSeries: 'chartEditor/addChartSeries',
    deleteChartSeries: 'chartEditor/deleteChartSeries',
    transposeData: 'chartEditor/transposeData',
    moveCells: 'chartEditor/moveCells',
    clearColumn: 'chartEditor/clearColumn',
    remap: 'chartEditor/remap'
  },
  projectConfig: {
    set: 'projectConfig/set',
    reset: 'projectConfig/reset',
    changeProjectName: 'projectConfig/changeProjectName',
    resetTheme: 'projectConfig/resetTheme',
    registerChangeMade: 'projectConfig/registerChangeMade',
    unsetChangeMade: 'projectConfig/unsetChangeMade',
    toggleInspired: 'projectConfig/toggleInspired',
    toggleUnsavedChangesModal: 'projectConfig/toggleUnsavedChangesModal',
    unpublish: 'projectConfig/unpublish',
    toggleUnpublishModal: 'projectconfig/toggleUnpublishModal',
    showSignupModal: 'projectconfig/showSignupModal',
    getThemes: 'projectconfig/getThemes',
    updateDataAndConfig: 'projectConfig/updateDataAndConfig',
    addDataSeries: 'projectConfig/addDataSeries',
    sortData: 'projectConfig/sortData',
    deleteSeries: 'projectConfig/deleteSeries',
    updateSeriesMapping: 'projectConfig/updateSeriesMapping',
    updateDataAndConfigBulk: 'projectConfig/updateDataAndConfigBulk',
    clearDataGrid: 'projectConfig/clearDataGrid',
    movedColumns: 'projectConfig/movedColumns',
    movedRows: 'projectConfig/movedRows',
    handleDeletedColumn: 'projectConfig/handleDeletedColumn',
    clearColumn: 'projectConfig/clearColumn',
    deleteColumnFromOptions: 'projectConfig/deleteColumnFromOptions',
    updateCSSModules: 'projectConfig/updateCSSModules'
  },
  themeEditor: {
    saveTheme: 'themeEditor/saveTheme',
    loadTheme: 'themeEditor/loadTheme'
  },
  app: {
    set: 'app/set'
  },
  profile: {
    getProfile: 'profile/getProfile',
    getGroups: 'profile/getGroups',
    getSubscription: 'profile/getSubscription',
    setTeam: 'profile/setTeam',
    setTeams: 'profile/setTeams',
    setSubteam: 'profile/setSubteam',
    setSubteams: 'profile/setSubteams',
    setAll: 'profile/setAll',
    setLoading: 'profile/setLoading',
    setAnnouncements: 'profile/setAnnouncements',
    updateTeams: 'profile/updateTeams',
    deleteTeam: 'profile/deleteTeam',
    reloadDivisions: 'profile/reloadDivisions',
    logout: 'profile/logout',
    updateChartCount: 'profile/updateChartCount'
  }
};

export default actionTypes;
